import React from 'react';

const SimpleTest: React.FC = () => {
  return (
    <div className="bg-green-100 p-4 rounded border-2 border-green-500">
      <h4>✅ Simple Test Component</h4>
      <p>This component should work in MDX if the system is working correctly.</p>
    </div>
  );
};

export default SimpleTest;
